export const SET_FETCH_NOTIFICATION_TYPE = 'SET_FETCH_NOTIFICATION_TYPE';
export const DEL_FETCH_NOTIFICATION_TYPE = 'DEL_FETCH_NOTIFICATION_TYPE';
export const SET_FETCH_ACCIDENT_NOTIFICATION_TYPE = 'SET_FETCH_ACCIDENT_NOTIFICATION_TYPE';
export const DEL_FETCH_ACCIDENT_NOTIFICATION_TYPE = 'DEL_FETCH_ACCIDENT_NOTIFICATION_TYPE';







// WEBPACK FOOTER //
// ./src/store/modules/notification/action-types.js